import { buildClassesHook } from '../../helpers/styles';

export const useClasses = buildClassesHook({
    title: {
        textAlign: 'center',
        flex: '1 0 auto',
    },
});
